import { useLocalSearchParams } from "expo-router";
import { CameraGrid } from "@src/components/web/CameraGrid.web";
import { WebLayout } from "@src/components/web/WebLayout.web";
import { useCameraSearchSort } from "@src/features/cameras";

export function OverviewScreenContent() {
  const params = useLocalSearchParams<{ siteId?: string }>();
  const siteId = params.siteId;
  const { searchQuery, setSearchQuery, sortBy, setSortBy } = useCameraSearchSort();

  return (
    <WebLayout>
      <CameraGrid
        siteId={siteId}
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
        sortBy={sortBy}
        onSortChange={setSortBy}
      />
    </WebLayout>
  );
}
